import React from 'react';
const IconDownload = ({color}) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.333 14h9.334v-1.333H3.333m9.334-6H10v-4H6v4H3.333L8 11.333l4.667-4.666z" fill={color} fill-rule="evenodd"/>
    </svg>
  )
}
export default IconDownload;
